import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { list_support_agents } from "@/graphql/queries";

export default {
  data() {
    return {
      agentsList: [],
    };
  },
  methods: {
    async fetchAgents() {
      try {
        const response = await client.graphql({
          query: list_support_agents,
        });

        const rawPayload = response.data.list_support_agents;
        const responseData =
          typeof rawPayload === "string" ? JSON.parse(rawPayload) : rawPayload;

        if (responseData.status == "SUCCESS" || responseData.success === true) {
          const data = responseData.data;
          this.agentsList = Array.isArray(data) ? data : [];
        } else {
          this.agentsList = [];
        }
      } catch (error) {
        console.error("Error fetching agents:", error);
        this.agentsList = [];
      }
    },
  },
};
